module.exports = __webpack_public_path__ + "img/truck.37838531.svg";